import { formatMixins } from '../mixins/format.mixins';
import { MatrixType } from '../models/matrix-type.enum';
import { ProductsFilter } from '../models/products-filter.model';
import { ProductsMatrix } from '../models/products-matrix.model';
import { CrudService } from './crud.service';
export class ProductsMatrixService {
  private crudService: CrudService<any>;

  constructor() {
    this.crudService = new CrudService<any>('products-matrix');
  }

  public async getProductsFilters(
    accountId: string,
    matrixType: MatrixType,
    orderDate?: Date,
    orderNumber?: string,
  ): Promise<ProductsFilter[]> {
    const validationResult = await this.crudService.do(
      'get',
      `products-filters/undefined/${matrixType}?accountId=${accountId}${
        orderDate ? `&orderDate=${formatMixins.formatDateToIsoStringIgnoringTime(orderDate)}` : ''
      }${orderNumber ? `&orderNumber=${orderNumber}` : ''}`,
    );
    return validationResult.isValid() ? (validationResult.model as ProductsFilter[]) : new Array<ProductsFilter>();
  }

  public async getProductsMatrix(
    itemGroupNames: string[],
    accountId: string,
    orderDate: Date,
    matrixType: string,
    collectionNames?: string[],
    orderNumber?: string,
  ): Promise<ProductsMatrix> {
    const joinedItemGroupNames = itemGroupNames.reduce(
      (itemGroupNamesAcc, itemGroupName, index) =>
        `${index === 0 ? '' : `${itemGroupNamesAcc}&`}itemGroupNames=${encodeURIComponent(itemGroupName)}`,
      '',
    );

    const validationResult = await this.crudService.do(
      'get',
      '?' +
        [
          `accountId=${accountId}`,
          `matrixType=${encodeURIComponent(matrixType)}`,
          `orderDate=${formatMixins.formatDateToIsoStringIgnoringTime(orderDate)}`,
          joinedItemGroupNames,
          `${collectionNames?.length ? `collectionNames=${encodeURIComponent(collectionNames.join(','))}` : ''}`,
          `${orderNumber ? `orderNumber=${orderNumber}` : ''}`,
        ].join('&'),
    );
    return validationResult.isValid() ? (validationResult.model as ProductsMatrix) : new ProductsMatrix();
  }
}
